import React from 'react';
import { Link } from 'react-router-dom';
import image9 from "../images/Images Webp/Blog-1.webp";
import image6 from "../images/Images Webp/blog3.webp";
import image7 from "../images/img_low_angle_coupl.png";
import image8 from "../images/Images Webp/weddingDay.webp";
import image1 from "../images/Images Webp/hayya-Nonmuslim.webp"
import Footer from "./Footer";  

const BlogPage = () => {
  const articles = [
    {
      image: image9,
      title: 'Before the Wedding Day',
      excerpt: 'A Week of Preparation and Celebration in Tunisian Weddings.',
      author: 'Hayya Team',
      date: 'June 20, 2024',
      slug: 'blog1' 
    },
  
    {
      image: image8,
      title: 'The Wedding Day',
      excerpt: 'The Big Day Arrives! A Celebration of Love in Tunisian Weddings.',
      author: 'Slim Khaled',
      date: 'June 20, 2024',
      slug: 'blog2'
    },
    {
      image: image6,
      title: 'The big finale',
      excerpt: 'Prenuptial Agreements and Islamic Marriage in Tunisia: Combining Love and Legality.',
      author: 'Seif ben ammar',
      date: 'June 21, 2024',
      slug: 'blog3'
    },
    {
      image: image7,
      title: 'Prenup and Islamic Marriage in Tunisia',
      excerpt: 'Prenup and Islamic Marriage in Tunisia: Combining Love and Legality.',
      author: 'Hayya Team',
      date: 'June 22, 2024',
      slug: 'blog4'
    },
    {
      image: image1,
      title: 'Marriage with a non-Muslim',
      excerpt: 'Marriage with a Non-Muslim: The Perilous Administrative Journey of Tunisian Women, Told with a Touch of Humor and Emotion.',
      author: 'Anas ben ali',
      date: 'June 23, 2024',
      slug: 'blog5'
    },
  ];

  return (
    <><div className="container mx-auto px-4 md:px-0 pb-8">
      <div className="text-center mt-8 mb-6">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900">Blogs</h1>
        <p className="text-lg text-gray-700">Our best written blogs</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
        {articles.map((article, index) => (
          <Link key={index} to={`/${article.slug}`} className="max-w-sm rounded-lg overflow-hidden shadow-lg bg-white hover:shadow-xl transition duration-300 ease-in-out transform hover:-translate-y-1">
            <img
              loading="lazy"
              src={article.image}
              className="w-full h-auto"
              alt={article.title} />
            <div className="px-6 py-4">
              <div className="font-bold text-xl mb-2">{article.title}</div>
              <p className="text-gray-700 text-base">{article.excerpt}</p>
            </div>
            <div className="px-6 pt-4 pb-2">
              <span className="inline-block bg-red-300 rounded-full px-3 py-1 text-sm font-semibold text-white mr-2">H</span>
              <span className="text-gray-700 text-sm">{article.author}</span>
              <span className="text-gray-600 text-sm float-right">{article.date}</span>
            </div>
          </Link>
        ))}
      </div>
    </div><Footer /></>
  );
};

export default BlogPage;
